<template>
  <div>
    <TextareaFormGroup
        v-model="data.content"
        name="content"
        label="Content"
        :error="(errors.content || [])[0]"
    />

    <TextFormGroup
        v-model="data.author"
        name="author"
        label="Author"
        :error="(errors.author || [])[0]"
    />
  </div>
</template>

<script>
import TextFormGroup from "../../../../vendor/forms/FormGroups/Block/Text.vue";
import TextareaFormGroup from "../../../../vendor/forms/FormGroups/Block/Textarea.vue";

export default {
  components: {TextFormGroup,TextareaFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
